import React, { useEffect, useState } from 'react';
import { SetTimer, timerUtils } from '../../../utilities/timer';
import { SubWindow } from '../../../utilities/subWindow';
import {
  RedirectingBackToScreen,
  RedirectingBackToScreenProps,
} from './molecules/RedirectingBackToScreen';
import {
  ReferBackToClientScreen,
  ReferBackToClientScreenProps,
} from './molecules/ReferBackToClientScreen';

type RedirectBackToWebProps = {
  clientName: string;
  setTimer?: SetTimer;
  window?: SubWindow;
  ReferBack?: React.ComponentType<ReferBackToClientScreenProps>;
  RedirectBack?: React.ComponentType<RedirectingBackToScreenProps>;
};

export const RedirectBackToWeb: React.FC<RedirectBackToWebProps> = ({
  clientName,
  setTimer = timerUtils.setTimer,
  window = new SubWindow(),
  ReferBack = ReferBackToClientScreen,
  RedirectBack = RedirectingBackToScreen,
}: RedirectBackToWebProps) => {
  const [isCloseAttemptDone, setIsCloseAttemptDone] = useState<boolean>(false);

  useEffect(() => {
    setTimer(() => {
      window.close();
    }, 2000);

    setTimer(() => {
      setIsCloseAttemptDone(true);
    }, 2500);
  }, [window, setTimer]);

  if (isCloseAttemptDone) return <ReferBack clientName={clientName} />;

  return <RedirectBack clientName={clientName} />;
};
